import { SelectOptionType } from "types";

export enum ApprovalEnum {
  PENDING = 1,
  REVISED = 2,
  REJECTED = 3,
  APPROVED = 4
}

export const APPROVAL_DROPDOWN_DATA: SelectOptionType[] = [
  { value: "", label: "All" },
  { value: ApprovalEnum.PENDING.toString(), label: "PENDING" },
  { value: ApprovalEnum.REVISED.toString(), label: "REVISI" },
  { value: ApprovalEnum.REJECTED.toString(), label: "REJECT" },
  { value: ApprovalEnum.APPROVED.toString(), label: "APPROVE" }, 
]